import { useDispatch } from 'react-redux'
import useSWR from 'swr'

import { fetchBrainTreeClientToken } from '@library/api-payment'

import { actionTypes } from 'actions/actionTypes'
import statusActions from 'actions/status'
import { trackCheckoutError } from 'actions/tracking'

const fetchBraintreeClientToken = async () => {
  const tokenResponse = await fetchBrainTreeClientToken()
  if (!tokenResponse.clientToken) {
    throw new Error('Failed to fetch braintree client token')
  }

  return tokenResponse.clientToken
}

export const useBraintreeClientToken = () => {
  const dispatch = useDispatch()
  const { data } = useSWR('braintree-client-token', fetchBraintreeClientToken, {
    onSuccess: (token) => {
      dispatch({ type: actionTypes.PAYMENT_SET_PAYPAL_CLIENT_TOKEN, token })
    },
    onErrorRetry: (err, _key, _config, revalidate, { retryCount }) => {
      if (err && retryCount < 3) {
        setTimeout(() => revalidate({ retryCount }), 3000)
      } else {
        dispatch(
          trackCheckoutError(actionTypes.PAYPAL_TOKEN_FETCH_FAILED, true, 'fetchPayPalClientToken'),
        )
        dispatch(statusActions.error(actionTypes.PAYPAL_TOKEN_ERROR_AT_CHECKOUT, true))
      }
    },
    revalidateOnFocus: false,
  })

  return { braintreeToken: data }
}
